'use client';

import { useInView } from '@/hooks/useInView';

interface FadeInSectionProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  threshold?: number;
}

/**
 * Wraps children in a div that fades + slides up when scrolled into view.
 * Use this around Server Component sections to avoid making them client components.
 */
export function FadeInSection({
  children,
  className = '',
  delay = 0,
  threshold = 0.1,
}: FadeInSectionProps) {
  const [ref, inView] = useInView<HTMLDivElement>({ threshold });

  return (
    <div
      ref={ref}
      style={{ transitionDelay: `${delay}ms` }}
      className={`transition-all duration-700 ${
        inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      } ${className}`}
    >
      {children}
    </div>
  );
}
